import { sendViewEvent } from "../analytics";

document.addEventListener("DOMContentLoaded", sendViewEvent);